import Button from 'components/gruenland/atoms/button/Button';
import EmptyMessage from 'components/gruenland/atoms/empty-message/EmptyMessage';
import WishlistItem from 'components/gruenland/molecules/wishlist-item';
import { useFormat } from 'helpers/hooks/useFormat';
import { LineItem, Wishlist as WishlistShape } from 'types/entity/wishlist';

export interface Props {
  wishlist?: WishlistShape;
  onRemoveFromWishlist?: (lineItemId: string) => Promise<void>;
  onMoveToCart?: (lineItem: LineItem) => Promise<void>;
  onClearWishlist?: () => Promise<void>;
}

const Wishlist: React.FC<Props> = ({ wishlist, onRemoveFromWishlist, onMoveToCart, onClearWishlist }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <>
      {!wishlist?.lineItems?.length ? (
        <EmptyMessage>
          {formatMessage({
            id: 'wishlist.empty',
            defaultMessage: 'Non hai nessun articolo nella tua lista dei desideri.',
          })}
        </EmptyMessage>
      ) : (
        <>
          <div className="h-[83vh] grow divide-y divide-neutral-400 overflow-auto px-3 md:px-[22px]">
            {wishlist?.lineItems?.map((lineItem) => (
              <WishlistItem
                key={lineItem.lineItemId}
                item={lineItem}
                onRemove={async () => onRemoveFromWishlist?.(lineItem.lineItemId as string)}
                onMoveToCart={async () => onMoveToCart?.(lineItem)}
              />
            ))}
          </div>
          <div className="absolute bottom-0 h-[88px] w-full p-5">
            <Button onClick={onClearWishlist} variant="buttonSecondary" className="w-full">
              {formatMessage({ id: 'wishlist.clear', defaultMessage: 'Svuota la lista dei desideri' })}
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Wishlist;
